import { Component, ViewEncapsulation, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { CraneListService } from "../../services/craneListService";
import { Router } from "@angular/router";
import { ImageAngleFromCenterComponent } from "../ImageAngleFromCenter/ImageAngleFromCenter.component";
import { AppStateService } from "../../services/appState.service";
import { KranSetupAllgemeinComponent } from "./kranSetupAllgemein.component";
import * as allgemeineFunktionen from "../../allgemeinesTS_CSS/allgemeineHilfsfunktionen";
import { Drehbereich } from "./Drehbereich";

@Component({
  selector: "app-crane-setup",
  templateUrl: "./maxBase.component.html",
  styleUrls: [
    "./kranSetupAllgemein.component.css",
    "./egrid.css",
    "../../allgemeinesTS_CSS/tooltip.css",
    "../../allgemeinesTS_CSS/cssButton.css",
  ],
  providers: [CraneListService],
  encapsulation: ViewEncapsulation.None,
})
export class MaxBaseComponent
  extends KranSetupAllgemeinComponent
  implements OnInit
{
  public grafikBasis = "deps/images/";
  public drehWinkelGrafik = "deps/images/KranDraufsicht.png";
  private gesetzterDrehbereich = [""];
  public gesetzteAbstuetzungUngespiegelt = "";
  public Abstuetzverteilung: string;
  public stuetzeVL = "";
  public stuetzeVR = "";
  public stuetzeHL = "";
  public stuetzeHR = "";
  private stuetzeVLPos; // = 5;
  private stuetzeVRPos; // = 5;
  private stuetzeHLPos; // = 5;
  private stuetzeHRPos; // = 5;
  private stuetzenDaten: Object;
  private stuetzenMuster: string[];
  public OWWinkel = "";
  private DrehbereichListe: Drehbereich[];

  constructor(
    private fb: FormBuilder,
    private craneListService: CraneListService,
    private router: Router,
    private appStateService: AppStateService
  ) {
    super(fb, craneListService, router, appStateService);
  }
  /**
   * Eine Funktion in der man Testausgaben unterbringen kann.
   * Im Template die Zeilen am Ende einkommentieren damit man einen Button hat zum Aufrufen.
   */
  testWas() {}
  ngOnInit() {
    this.tabellenEinstellungen["selectionMode"] = { selectionMode: ["row"] };
    this.tabellenEinstellungen["pageSettings"] = { pageSize: 10 };
    this.appStateService.appStatusVonServerHolen().then((res) => {
      if (res["loginStatus"] !== "loggedIn") {
        this.router.navigate(["/"]);
      }
      this.appStateService.appStatusSetzen({
        aktuellerMenuePunkt: "CraneSetup",
        PrintOut: "inactive",
      });
      this.gewichtsEinheit = this.appStateService.holeEinheitenSystem("G");
      this.laengenEinheit = this.appStateService.holeEinheitenSystem("L");
      if (this.appStateService.aktuellerAppStatus["einheitenSystem"] === "M") {
        this.stellenNachEinheitenSystem = 2;
      } else {
        this.stellenNachEinheitenSystem = 1;
      }
      if (this.appStateService.aktuellerAppStatus["kranname"] !== undefined) {
        this.kranname = this.appStateService.aktuellerAppStatus["kranname"];
      }
      // Tabelle laden
      console.log("Start: " + allgemeineFunktionen.holeUhrzeit());
      this.ladeKran = true;
      if (
        this.kranKennung["kranDatenbankNamen"] === undefined &&
        (this.appStateService.aktuellerAppStatus["kranDatenbankNamen"] ===
          undefined ||
          this.appStateService.aktuellerAppStatus["kranDatenbankNamen"] === "")
      ) {
        this.zeigeFehler("No crane selected", "Please chosse a crane.", () => {
          this.router.navigate(["/craneSelection"]);
        });
        return;
      } else {
        this.kranKennung["kranDatenbankNamen"] =
          this.appStateService.aktuellerAppStatus["kranDatenbankNamen"];
      }
      // erzeuge Datenbank auf dem Server und hole Daten für das Formular
      this.ladeRuestzustand = true;
      if (
        this.appStateService.aktuellerAppStatus["abstuetzVerteilung"] ===
          undefined ||
        this.appStateService.aktuellerAppStatus["abstuetzVerteilung"] === ""
      ) {
        this.Abstuetzverteilung = "VH";
      } else {
        this.Abstuetzverteilung =
          this.appStateService.aktuellerAppStatus["abstuetzVerteilung"];
      }
      this.SetupForm.get("Abstuetzverteilung").setValue(
        this.Abstuetzverteilung
      );
      this.RHLRadius =
        this.appStateService.aktuellerAppStatus["RHLRadius"] === undefined ||
        this.appStateService.aktuellerAppStatus["RHLRadius"] === "null"
          ? ""
          : this.appStateService.aktuellerAppStatus["RHLRadius"];
      this.SetupForm.get("Radius").setValue(this.RHLRadius);
      this.RHLLast =
        this.appStateService.aktuellerAppStatus["RHLLast"] === undefined ||
        this.appStateService.aktuellerAppStatus["RHLLast"] === "null"
          ? ""
          : this.appStateService.aktuellerAppStatus["RHLLast"];
      this.SetupForm.get("Last").setValue(this.RHLLast);
      this.RHLHoehe =
        this.appStateService.aktuellerAppStatus["RHLHoehe"] === undefined ||
        this.appStateService.aktuellerAppStatus["RHLHoehe"] === "null"
          ? ""
          : this.appStateService.aktuellerAppStatus["RHLHoehe"];
      this.SetupForm.get("Hoehe").setValue(this.RHLHoehe);
      this.craneListService.holeRuestdaten().then((res1) => {
        this.einlesenRuestdaten(res1); // wichtig wenn schon ein Kran geladen ist und man zurück kommt.
        this.craneListService
          .getPartsSelectionData(
            this.kranKennung["kranDatenbankNamen"],
            this.Abstuetzverteilung,
            this.RHLRadius,
            this.RHLLast,
            this.RHLHoehe,
            this.ruestFilter
          )
          .then((res2) => {
            this.ladeRuestzustaende(res2);
            this.craneListService
              .getKranTabelle(this.kranKennung["kranDatenbankNamen"])
              .then((res3) => {
                this.ladeTabelle(res3);
              });
          });
      });
    });
    this.erzeugeHTMLFormular();
  }
  erzeugeHTMLFormular() {
    // erzeuge das Setupformular
    this.SetupForm = this.fb.group({
      Radius: [this.RHLRadius],
      Last: [this.RHLLast],
      Hoehe: [this.RHLHoehe],
      Kombination: [this.gesetzteKombination],
      Identnr: [this.gesetzteIdentnr],
      Gegengew: [this.gesetztesGegengew],
      AbstuetzW: [this.gesetzteAbstuetzung],
      HALaenge: [this.gesetzteHALaenge],
      HAAusfahrf: [this.gesetzteHAAusfahrf],
      Drehrichtung: [""],
      OWWinkel: [this.OWWinkel],
      HintenRechts: [""],
      HintenLinks: [""],
      VorneRechts: [""],
      VorneLinks: [""],
      Abstuetzverteilung: [this.Abstuetzverteilung],
    });
  }
  einlesenRuestdaten(res) {
    res["Identnr"] = ""; // Da wir die Chartnummern nicht nutzen. Code bleibt, da wir sie u.U. ja doch noch einmal nutzen
    super.einlesenRuestdaten(res);

    // AbstuetzW aus ruestfilter nehmen damit alle möglichen Abstuetzungen wählbar werden.
    // Filterung ist dann nur noch über VH, HV, LR, 0G
    delete this.ruestFilter["Abstuetzung"];
    //    this.OWWinkel = res['OWWinkel'] !== undefined ? res['OWWinkel'] : '';
    if (res["OWWinkel"] !== undefined) {
      this.aendereOWWinkel(res["OWWinkel"], true, false);
      this.SetupForm.get("OWWinkel").setValue(this.OWWinkel);
    }
    // OWWinkel an Grove anpassen.
    if (parseFloat(this.OWWinkel) > 180) {
      const test = allgemeineFunktionen.rundeZahl(
        parseFloat(this.OWWinkel) - 360,
        2
      );
      this.OWWinkel = test.toString();
    }
    if (res["Abstuetzung"] !== undefined && res["Abstuetzung"] !== "") {
      this.gesetzteAbstuetzung = res["Abstuetzung"];
      this.SetupForm.get("AbstuetzW").setValue(this.gesetzteAbstuetzung);
      if (this.appStateService.aktuellerAppStatus["seiteSpiegeln"]) {
        // Kranmodell auf Server drehen! Sonst gibt es später Chaos.
        this.craneListService.spiegleKranWennNoetig();
        this.gesetzteAbstuetzungUngespiegelt = this.gesetzteAbstuetzung
          .replace("LR", "RL")
          .replace("HR", "HL")
          .replace("VR", "VL");
      } else {
        this.gesetzteAbstuetzungUngespiegelt = this.gesetzteAbstuetzung;
      }
      // XXX Sollte es Probleme mit den Filtern geben hier mal nach schauen
      //      this.KranFilterTabelle.widget.filterColumn('AbstuetzW', 'equal', this.gesetzteAbstuetzungUngespiegelt, 'and', true);
      this.KranFilterTabelle.widget.filterColumn(
        "AbstuetzW",
        "equal",
        this.gesetzteAbstuetzung,
        "and",
        true
      );
    } else {
      this.gesetzteAbstuetzung = "";
      this.SetupForm.get("AbstuetzW").setValue("");
      this.KranFilterTabelle.widget.clearFiltering("AbstuetzW");
    }

    if (
      this.appStateService.aktuellerAppStatus["abstuetzMuster"] !== undefined &&
      this.appStateService.aktuellerAppStatus["abstuetzMuster"] !== ""
    ) {
      this.stuetzeVLPos = parseInt(
        this.appStateService.aktuellerAppStatus["abstuetzMuster"].substr(0, 1),
        10
      );
      this.stuetzeVRPos = parseInt(
        this.appStateService.aktuellerAppStatus["abstuetzMuster"].substr(1, 1),
        10
      );
      this.stuetzeHLPos = parseInt(
        this.appStateService.aktuellerAppStatus["abstuetzMuster"].substr(2, 1),
        10
      );
      this.stuetzeHRPos = parseInt(
        this.appStateService.aktuellerAppStatus["abstuetzMuster"].substr(3, 1),
        10
      );
    } else {
      this.stuetzeVLPos =
        this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
      this.stuetzeVRPos =
        this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
      this.stuetzeHLPos =
        this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
      this.stuetzeHRPos =
        this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
    }
    this.setzeAbstuetzungen();
  }
  goMaxBaseControl() {
    if (this.OWWinkel === "" || this.OWWinkel === undefined) {
      switch (
        this.KranFilterTabelle.widget.getSelectedRecords()[0].Drehrichtung
      ) {
        case "1": {
          this.kranKennung["owWinkel"] = "0";
          break;
        }
        case "2": {
          this.kranKennung["owWinkel"] = "180";
          break;
        }
        case "3": {
          this.kranKennung["owWinkel"] = "-90";
          break;
        }
        case "4": {
          this.kranKennung["owWinkel"] = "90";
          break;
        }
      }
      this.appStateService.kranGewaehltNeu(this.kranKennung);
    }
    this.router.navigate(["/controlMaxBase"]);
  }
  rowSelected() {
    this.kranKennung["abstuetzMuster"] =
      String(this.stuetzeVLPos) +
      String(this.stuetzeVRPos) +
      String(this.stuetzeHLPos) +
      String(this.stuetzeHRPos);
    this.kranKennung["abstuetzProzenteVL"] = this.abstuetzProzente(
      this.stuetzeVLPos
    );
    this.kranKennung["abstuetzProzenteVR"] = this.abstuetzProzente(
      this.stuetzeVRPos
    );
    this.kranKennung["abstuetzProzenteHL"] = this.abstuetzProzente(
      this.stuetzeHLPos
    );
    this.kranKennung["abstuetzProzenteHR"] = this.abstuetzProzente(
      this.stuetzeHRPos
    );
    this.kranKennung["abstuetzVerteilung"] = this.Abstuetzverteilung;
    if (this.gesetzteAbstuetzung !== this.gesetzteAbstuetzungUngespiegelt) {
      this.kranKennung["seitenSpiegeln"] = true;
    } else {
      this.kranKennung["seitenSpiegeln"] = false;
    }
    this.kranKennung["owWinkel"] = this.OWWinkel;
    super.rowSelected();
  }
  abstuetzProzente(abstuetzungPostition: number) {
    if (
      this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"] ===
      "3"
    ) {
      switch (abstuetzungPostition) {
        case 0:
        case 1:
          return "0";
        case 2:
          return "50";
        case 3:
        case this.appStateService.aktuellerAppStatus[
          "anzahlAbstuetzPositionen"
        ]:
          return "100";
        default:
          return "0";
      }
    } else if (
      this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"] ===
      "5"
    ) {
      switch (abstuetzungPostition) {
        case 0:
        case 1:
          return "0";
        case 2:
          return "50";
        case 3:
          return "66";
        case 4:
          return "83";
        case this.appStateService.aktuellerAppStatus[
          "anzahlAbstuetzPositionen"
        ]:
          return "100";
        default:
          return "0";
      }
    }
  }
  erzeugeListeErlaubterAbstuetzungen(): Promise<any> {
    if (this.stuetzenDaten === undefined) {
      // Daten wurden noch nicht geladen. Jetzt aus DB holen.
      return this.craneListService
        .getStuetzenDaten(this.kranKennung["kranDatenbankNamen"])
        .then((res) => {
          this.erzeugeStuetzenObjektEintrag(res);
          this.erzeugeAbstuetzungsFilter();
        });
    }
  }
  erzeugeStuetzenObjektEintrag(res) {
    this.stuetzenDaten = new Object();
    this.stuetzenMuster = [];
    let i = 0;
    for (const zeile of res) {
      zeile["Position"] = i + 1;
      i++;
      this.stuetzenDaten[zeile.Weite] = zeile;
    }
    const maxCountOutriggerPosition =
      this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
    for (const abstuetzung of this.abstuetzungen) {
      if (abstuetzung === "") {
      } else if (abstuetzung.indexOf("1xHL") > -1) {
        this.stuetzenMuster.push(
          maxCountOutriggerPosition +
            maxCountOutriggerPosition +
            maxCountOutriggerPosition +
            "1"
        );
      } else if (abstuetzung.indexOf("1xVL") > -1) {
        this.stuetzenMuster.push(
          maxCountOutriggerPosition +
            "1" +
            maxCountOutriggerPosition +
            maxCountOutriggerPosition
        );
      } else if (abstuetzung.indexOf("1xHR") > -1) {
        this.stuetzenMuster.push(
          maxCountOutriggerPosition +
            maxCountOutriggerPosition +
            "1" +
            maxCountOutriggerPosition
        );
      } else if (abstuetzung.indexOf("1xVR") > -1) {
        this.stuetzenMuster.push(
          "1" +
            maxCountOutriggerPosition +
            maxCountOutriggerPosition +
            maxCountOutriggerPosition
        );
      } else if (abstuetzung.indexOf("x") > -1) {
        const abstuetzVerteilung: string[] = abstuetzung
          .substring(0, abstuetzung.length - this.laengenEinheit.length)
          .split("x");

        for (let z = 0; z <= 1; z++) {
          if (z % 2 === 1) {
            abstuetzVerteilung[z] = (
              Math.floor((parseFloat(abstuetzVerteilung[z]) / 2) * 100) / 100
            ).toString();
          }
          if (abstuetzVerteilung[z].endsWith("0")) {
            abstuetzVerteilung[z] = abstuetzVerteilung[z].substring(
              0,
              abstuetzVerteilung[z].length - 1
            );
          }
        }
        abstuetzVerteilung[1] = (
          Math.round(parseFloat(abstuetzVerteilung[1]) * 100) / 100
        ).toString();
        this.stuetzenMuster.push(
          String(
            this.sucheStuetzenDaten(abstuetzVerteilung[1], 0.5, 0.01)[
              "Position"
            ]
          ) +
            String(
              this.sucheStuetzenDaten(abstuetzVerteilung[1], 0.5, 0.01)[
                "Position"
              ]
            ) +
            String(
              this.sucheStuetzenDaten(abstuetzVerteilung[1], 0.5, 0.01)[
                "Position"
              ]
            ) +
            String(
              this.sucheStuetzenDaten(abstuetzVerteilung[1], 0.5, 0.01)[
                "Position"
              ]
            )
        );
      } else {
        const abstuetzVerteilung: string[] = abstuetzung
          .substring(3, abstuetzung.length - this.laengenEinheit.length)
          .split("/");
        for (let z = 0; z <= 1; z++) {
          abstuetzVerteilung[z] = (
            Math.round(
              parseFloat(abstuetzVerteilung[z].replace(",", ".")) * 100
            ) / 100
          ).toString();
        }
        for (let z = 0; z <= 1; z++) {
          if (abstuetzVerteilung[z].endsWith("0")) {
            abstuetzVerteilung[z] = abstuetzVerteilung[z].substring(
              0,
              abstuetzVerteilung[z].length - 1
            );
          }
        }
        if (abstuetzung.startsWith("HV_") === true) {
          this.stuetzenMuster.push(
            String(
              this.sucheStuetzenDaten(abstuetzVerteilung[1], 0.5, 0.01)[
                "Position"
              ]
            ) +
              String(
                this.sucheStuetzenDaten(abstuetzVerteilung[1], 0.5, 0.01)[
                  "Position"
                ]
              ) +
              String(
                this.sucheStuetzenDaten(abstuetzVerteilung[0], 0.5, 0.01)[
                  "Position"
                ]
              ) +
              String(
                this.sucheStuetzenDaten(abstuetzVerteilung[0], 0.5, 0.01)[
                  "Position"
                ]
              )
          );
        } else if (abstuetzung.startsWith("VH_") === true) {
          this.stuetzenMuster.push(
            String(
              this.sucheStuetzenDaten(abstuetzVerteilung[0], 0.5, 0.01)[
                "Position"
              ]
            ) +
              String(
                this.sucheStuetzenDaten(abstuetzVerteilung[0], 0.5, 0.01)[
                  "Position"
                ]
              ) +
              String(
                this.sucheStuetzenDaten(abstuetzVerteilung[1], 0.5, 0.01)[
                  "Position"
                ]
              ) +
              String(
                this.sucheStuetzenDaten(abstuetzVerteilung[1], 0.5, 0.01)[
                  "Position"
                ]
              )
          );
        } else if (abstuetzung.startsWith("RL_") === true) {
          this.stuetzenMuster.push(
            String(
              this.sucheStuetzenDaten(abstuetzVerteilung[1], 0.5, 0.01)[
                "Position"
              ]
            ) +
              String(
                this.sucheStuetzenDaten(abstuetzVerteilung[0], 0.5, 0.01)[
                  "Position"
                ]
              ) +
              String(
                this.sucheStuetzenDaten(abstuetzVerteilung[1], 0.5, 0.01)[
                  "Position"
                ]
              ) +
              String(
                this.sucheStuetzenDaten(abstuetzVerteilung[0], 0.5, 0.01)[
                  "Position"
                ]
              )
          );
        } else if (abstuetzung.startsWith("LR_") === true) {
          this.stuetzenMuster.push(
            String(
              this.sucheStuetzenDaten(abstuetzVerteilung[0], 0.5, 0.01)[
                "Position"
              ]
            ) +
              String(
                this.sucheStuetzenDaten(abstuetzVerteilung[1], 0.5, 0.01)[
                  "Position"
                ]
              ) +
              String(
                this.sucheStuetzenDaten(abstuetzVerteilung[0], 0.5, 0.01)[
                  "Position"
                ]
              ) +
              String(
                this.sucheStuetzenDaten(abstuetzVerteilung[1], 0.5, 0.01)[
                  "Position"
                ]
              )
          );
        }
      }
    }
  }
  /**
   * Sucht eine passende Abstützung zu einer Weite.
   * Aufgrund von Rundungen kann es sein, dass die Werte durch annäherung gefunden werden müssen
   * @param abstuetzVerteilung gibt die gesuchte weite der Abstuetzung an.
   * @param genauigkeit Gibt an, wie groß die Abweichung sein darf.
   * @param gibt Die Schrittweite an, mit der sich die Suche von der gegebgenen Weite entfernt.
   */
  sucheStuetzenDaten(
    abstuetzVerteilung: string,
    genauigkeit: number,
    korn: number
  ): string {
    let abweichung = 0;
    while (
      parseFloat(abstuetzVerteilung) + genauigkeit >=
      parseFloat(abstuetzVerteilung) + abweichung
    ) {
      if (
        allgemeineFunktionen.isset(
          this.stuetzenDaten[
            allgemeineFunktionen
              .rundeZahl(parseFloat(abstuetzVerteilung) + abweichung)
              .toString()
          ]
        )
      ) {
        return this.stuetzenDaten[
          allgemeineFunktionen
            .rundeZahl(parseFloat(abstuetzVerteilung) + abweichung)
            .toString()
        ];
      } else if (
        allgemeineFunktionen.isset(
          this.stuetzenDaten[
            allgemeineFunktionen
              .rundeZahl(parseFloat(abstuetzVerteilung) - abweichung)
              .toString()
          ]
        )
      ) {
        return this.stuetzenDaten[
          allgemeineFunktionen
            .rundeZahl(parseFloat(abstuetzVerteilung) - abweichung)
            .toString()
        ];
      } else {
        abweichung += korn;
      }
    }
    return null;
  }
  /**
   * lädt die Rüstzustände des Krans vom Server nach
   */
  ladeRuestzustaende(kranDaten): Promise<any> {
    //    this.appStateService.kranGewaehltNeu(this.kranKennung);
    super.ladeRuestzustaende(kranDaten);
    if (this.identnummern.length === 2) {
      // Sollten wir hier landen hat die Elternklasse vermutlich ein Filter auf die Identnr gesetzt. Wollen wir bei MAXbase nicht,
      // da sonst andere Sektoren nicht mehr korrekt gewählt werden können.
      this.gesetzteIdentnr = "";
      this.KranFilterTabelle.widget.clearFiltering("Identnr");
    }
    // Alle zurückgelieferten Abstuetzungen werden berücksichtigt, da die Filterung schon über die Abstuetzverteilung gefiltert ist.
    Array.prototype.push.apply(this.abstuetzungen, kranDaten["Abstuetzungen"]);
    // Abstuetzungen pruefen ob RL, HL oder VL vorhanden, dann die entsprechenden gespiegelten (LR, HR, VR) hinzufügen.
    this.abstuetzungen.forEach((element) => {
      if (element.indexOf("RL") > -1) {
        this.abstuetzungen.push(element.replace("RL", "LR"));
      } else if (element.indexOf("HL") > -1) {
        this.abstuetzungen.push(element.replace("HL", "HR"));
      } else if (element.indexOf("VL") > -1) {
        this.abstuetzungen.push(element.replace("VL", "VR"));
      }
    });
    return this.erzeugeListeErlaubterAbstuetzungen();
  }
  /**
   * setzt alle Filter zurück
   */
  resetFilter(art = "alles") {
    this.stuetzeVLPos =
      this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
    this.stuetzeVRPos =
      this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
    this.stuetzeHLPos =
      this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
    this.stuetzeHRPos =
      this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
    this.setzeAbstuetzungen();
    if (art === "alles") {
      this.SetupForm.reset({ Abstuetzverteilung: "VH" });
    }
    // else {
    //   this.SetupForm.reset({
    //     Abstuetzverteilung: 'VH',
    //     Radius: this.RHLRadius,
    //     Last: this.RHLLast,
    //     Hoehe: this.RHLHoehe
    //   });
    // }
    this.Abstuetzverteilung = "VH";
    this.SetupForm.get("Abstuetzverteilung").setValue(this.Abstuetzverteilung);
    this.aendereOWWinkel("");
    super.resetFilter(art);
    this.gesetzteAbstuetzungUngespiegelt = "";
    this.gesetzterDrehbereich = [""];
    this.erzeugeAbstuetzungsFilterWennAllesDa();
    return true;
  }
  async showOutriggerVariant(welchen: string) {
    if (
      this.appStateService.aktuellerAppStatus === undefined ||
      this.appStateService.aktuellerAppStatus["abstuetzVarianten"] === undefined
    ) {
      const waitForAppStatus = (property, timeout) =>
        new Promise((resolve, reject) => {
          const check = () => {
            if ((timeout -= 100) < 0) {
              reject("Status not available");
            }
            if (this.appStateService.aktuellerAppStatus !== undefined) {
              if (
                this.appStateService.aktuellerAppStatus[property] !== undefined
              ) {
                resolve("Status available");
              }
            }
          };
          setTimeout(check, 100);
        });

      const wait = await waitForAppStatus("abstuetzVarianten", 1000).then(
        (x) => x,
        (x) => x
      );

      if (wait !== "Status available") {
        return 0;
      }
    }
    let outriggerPattern: number;
    switch (welchen) {
      case "HV":
      case "VH":
        outriggerPattern = 1;
        break;
      case "LR":
      case "RL":
        outriggerPattern = 2;
        break;
      case "0":
        outriggerPattern = 4;
        break;
      case "50":
        outriggerPattern = 8;
        break;
      case "75":
        outriggerPattern = 16;
        break;
      default:
        outriggerPattern = 0;
        break;
    }
    return (outriggerPattern &
      this.appStateService.aktuellerAppStatus["abstuetzVarianten"]) >
      0
      ? true
      : false;
  }
  holeKranRuestzustaende(
    Identnr = "",
    Gegengew = "",
    HALAenge = "",
    AbstuetzW = "",
    HAAusfahrf = "",
    Abstuetzverteilung = "VH",
    Drehrichtung = "0",
    Kombination = "",
    HAWinkel = "",
    HI1Laenge = "",
    HI1Winkel = ""
  ): Promise<any> {
    Identnr = "";
    return super.holeKranRuestzustaende(
      Identnr,
      Gegengew,
      HALAenge,
      AbstuetzW,
      HAAusfahrf,
      Abstuetzverteilung,
      Drehrichtung,
      Kombination,
      HAWinkel,
      HI1Laenge,
      HI1Winkel
    );
  }
  ruestzustandAendern(event: any) {
    super.ruestzustandAendern(event);
    const zuAendernderRuestzustand = event.target.id;
    let neuerWert = event.target.value;
    switch (zuAendernderRuestzustand) {
      case "AbstuetzW":
        this.gesetzteAbstuetzung = neuerWert;
        this.SetupForm.get("AbstuetzW").setValue(neuerWert);
        // Falls es sich bei der gesetzten Abstuetzung um eine gespeigelte handel wird noch die ungespiegelte Bezeichung gesetzt.
        this.gesetzteAbstuetzungUngespiegelt = this.gesetzteAbstuetzung
          .replace("LR", "RL")
          .replace("VR", "VL")
          .replace("HR", "HL");
        break;
      default:
        break;
    }
    if (
      zuAendernderRuestzustand === "AbstuetzW" ||
      zuAendernderRuestzustand === "IdentNr"
    ) {
      this.stuetzenDaten = undefined; // Damit in holeKranRuestzustaende die StuetzMuster neu berechnet werden!
    }
    this.holeKranRuestzustaende(
      this.gesetzteIdentnr,
      this.gesetztesGegengew,
      this.gesetzteHALaenge,
      this.gesetzteAbstuetzungUngespiegelt,
      this.gesetzteHAAusfahrf,
      this.Abstuetzverteilung,
      this.gesetzterDrehbereich.join(","),
      this.gesetzteKombination,
      "", // this.gesetzterHAWinkel,
      "", // this.gesetzteHI1Laenge,
      "" // this.gesetzterHI1Winkel
    ).then(() => {
      // Anfang Aktion die erst ausgeführt werden dürfen wenn die Ruestzustaende geladen sind.
      this.setzeHALaengeAusfahrf(zuAendernderRuestzustand);
      // warten bis die StuetzenDaten und StuetzenMuster da sind.
      if (
        zuAendernderRuestzustand === "AbstuetzW" ||
        zuAendernderRuestzustand === "Identnr"
      ) {
        let position1 = "1";
        let position2 = "1";
        let position3 = "1";
        let position4 = "1";
        if (this.Abstuetzverteilung === "50G") {
          position1 = "2";
          position2 = "2";
          position3 = "2";
          position4 = "2";
        }
        if (this.gesetzteIdentnr !== "") {
          neuerWert = this.abstuetzungen[1];
        }
        if (zuAendernderRuestzustand === "Identnr") {
          if (
            this.gesetzteIdentnr === "" &&
            this.gesetzteAbstuetzung === "" &&
            this.Abstuetzverteilung !== "0G" &&
            this.Abstuetzverteilung !== "50G"
          ) {
            neuerWert = undefined;
            position1 =
              this.appStateService.aktuellerAppStatus[
                "anzahlAbstuetzPositionen"
              ];
            position2 =
              this.appStateService.aktuellerAppStatus[
                "anzahlAbstuetzPositionen"
              ];
            position3 =
              this.appStateService.aktuellerAppStatus[
                "anzahlAbstuetzPositionen"
              ];
            position4 =
              this.appStateService.aktuellerAppStatus[
                "anzahlAbstuetzPositionen"
              ];
          } else {
            neuerWert = this.abstuetzungen[1];
          }
        }
        if (neuerWert === undefined || neuerWert === "") {
          if (
            this.Abstuetzverteilung === "0G" ||
            this.Abstuetzverteilung === "50G"
          ) {
            position1 =
              this.appStateService.aktuellerAppStatus[
                "anzahlAbstuetzPositionen"
              ];
            position2 =
              this.appStateService.aktuellerAppStatus[
                "anzahlAbstuetzPositionen"
              ];
            position3 =
              this.appStateService.aktuellerAppStatus[
                "anzahlAbstuetzPositionen"
              ];
          } else {
            position1 =
              this.appStateService.aktuellerAppStatus[
                "anzahlAbstuetzPositionen"
              ];
            position2 =
              this.appStateService.aktuellerAppStatus[
                "anzahlAbstuetzPositionen"
              ];
            position3 =
              this.appStateService.aktuellerAppStatus[
                "anzahlAbstuetzPositionen"
              ];
            position4 =
              this.appStateService.aktuellerAppStatus[
                "anzahlAbstuetzPositionen"
              ];
          }
        } else if (neuerWert.indexOf("1xHR") > -1) {
          position1 =
            this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
          position2 =
            this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
          position3 =
            this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
        } else if (neuerWert.indexOf("1xHL") > -1) {
          position1 =
            this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
          position2 =
            this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
          position4 =
            this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
        } else if (neuerWert.indexOf("1xVL") > -1) {
          position2 =
            this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
          position3 =
            this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
          position4 =
            this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
        } else if (neuerWert.indexOf("1xVR") > -1) {
          position1 =
            this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
          position3 =
            this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
          position4 =
            this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
        } else if (neuerWert.indexOf("x") > -1) {
          // symmetrische Abstuetzung
          const abstuetzVerteilung: string[] = neuerWert
            .substring(0, neuerWert.length - 1)
            .split("x");
          for (let i = 0; i <= 1; i++) {
            if (abstuetzVerteilung[i].endsWith("0")) {
              abstuetzVerteilung[i] = abstuetzVerteilung[i].substring(
                0,
                abstuetzVerteilung[i].length - 1
              );
            }
          }
          position1 = String(
            this.stuetzenDaten[
              (parseFloat(abstuetzVerteilung[1]) / 2).toString()
            ]["Position"]
          );
          position2 = position1;
          position3 = position1;
          position4 = position1;
        } else {
          // HV, VH, LR, RL Abstuetzung
          const abstuetzVerteilung: string[] = neuerWert
            .substring(3, neuerWert.length - 1)
            .split("/");
          for (let i = 0; i <= 1; i++) {
            if (abstuetzVerteilung[i].endsWith("0")) {
              abstuetzVerteilung[i] = abstuetzVerteilung[i].substring(
                0,
                abstuetzVerteilung[i].length - 1
              );
            }
          }
          if (neuerWert.startsWith("HV_") === true) {
            position1 = String(
              this.stuetzenDaten[abstuetzVerteilung[1]]["Position"]
            );
            position2 = position1;
            position3 = String(
              this.stuetzenDaten[abstuetzVerteilung[0]]["Position"]
            );
            position4 = position3;
          } else if (neuerWert.startsWith("VH_") === true) {
            position1 = String(
              this.stuetzenDaten[abstuetzVerteilung[0]]["Position"]
            );
            position2 = position1;
            position3 = String(
              this.stuetzenDaten[abstuetzVerteilung[1]]["Position"]
            );
            position4 = position3;
          } else if (neuerWert.startsWith("RL_") === true) {
            position1 = String(
              this.stuetzenDaten[abstuetzVerteilung[1]]["Position"]
            );
            position2 = String(
              this.stuetzenDaten[abstuetzVerteilung[0]]["Position"]
            );
            position3 = position1;
            position4 = position2;
          } else if (neuerWert.startsWith("LR_") === true) {
            position1 = String(
              this.stuetzenDaten[abstuetzVerteilung[0]]["Position"]
            );
            position2 = String(
              this.stuetzenDaten[abstuetzVerteilung[1]]["Position"]
            );
            position3 = position1;
            position4 = position2;
          }
        }
        this.aendereAbstuetzung(
          position1,
          position2,
          position3,
          position4,
          true
        );
      }
      this.ladeRuestzustand = false;
      // Ende Aktion die erst ausgeführt werden dürfen wenn die Ruestzustaende geladen sind.
    });
  }
  aendereAbstuetzung(
    pos1: string,
    pos2: string,
    pos3: string = "1",
    pos4: string = "1",
    absolut: boolean = false
  ) {
    if (absolut) {
      // Werte werden geändert
      this.stuetzeVLPos = parseInt(pos1, 10);
      this.stuetzeVRPos = parseInt(pos2, 10);
      this.stuetzeHLPos = parseInt(pos3, 10);
      this.stuetzeHRPos = parseInt(pos4, 10);
    } else {
      // Das Allgemeine "else" muss ersetzt werden, sollte noch mal eine Filterung nach Supportbase erfolgen.
      //       else if (
      //         (this.gesetzteAbstuetzung === '' || this.gesetzteAbstuetzung === undefined)
      //          && (this.gesetzteIdentnr === '' || this.gesetzteIdentnr === undefined)
      //       ) {
      //      if (
      //        this.SetupForm.value['Abstuetzverteilung'] === '0G'
      //        && this.SetupForm.value['AbstuetzW'] !== ''
      //        && this.SetupForm.value['AbstuetzW'] !== undefined
      //      ) {
      //        if (this.stuetzeVLPos === 1) {
      //          this.stuetzeVLPos = 5;
      //          this.stuetzeVRPos = 1;
      //        } else if (this.stuetzeVRPos === 1) {
      //          this.stuetzeVLPos = 1;
      //          this.stuetzeVRPos = 5;
      //        } else if (this.stuetzeHLPos === 1) {
      //          this.stuetzeHLPos = 5;
      //          this.stuetzeHRPos = 1;
      //        } else if (this.stuetzeHRPos === 1) {
      //          this.stuetzeHRPos = 5;
      //          this.stuetzeHLPos = 1;
      //        }
      //      } else {
      // Werte werden geändert
      switch (pos1) {
        case "v":
        case "V":
          switch (pos2) {
            case "l":
              this.stuetzeVLPos--;
              if (this.stuetzeVLPos === 0) {
                this.stuetzeVLPos =
                  this.appStateService.aktuellerAppStatus[
                    "anzahlAbstuetzPositionen"
                  ];
              }
              switch (this.SetupForm.value["Abstuetzverteilung"]) {
                case "VH":
                  this.stuetzeVRPos = this.stuetzeVLPos;
                  break;
                case "LR":
                  this.stuetzeHLPos = this.stuetzeVLPos;
                  break;
                case "0G":
                  this.stuetzeVLPos = 1;
                  this.stuetzeVRPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeHLPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeHRPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  break;
                case "50G":
                  this.stuetzeVLPos = 2;
                  this.stuetzeVRPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeHLPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeHRPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  break;
              }
              break;
            case "r":
              this.stuetzeVRPos--;
              if (this.stuetzeVRPos === 0) {
                this.stuetzeVRPos =
                  this.appStateService.aktuellerAppStatus[
                    "anzahlAbstuetzPositionen"
                  ];
              }
              switch (this.SetupForm.value["Abstuetzverteilung"]) {
                case "VH":
                  this.stuetzeVLPos = this.stuetzeVRPos;
                  break;
                case "LR":
                  this.stuetzeHRPos = this.stuetzeVRPos;
                  break;
                case "0G":
                  this.stuetzeVLPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeVRPos = 1;
                  this.stuetzeHLPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeHRPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  break;
                case "50G":
                  this.stuetzeVLPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeVRPos = 2;
                  this.stuetzeHLPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeHRPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  break;
              }
              break;
          }
          break;
        case "h":
        case "H":
          switch (pos2) {
            case "l":
              this.stuetzeHLPos--;
              if (this.stuetzeHLPos === 0) {
                this.stuetzeHLPos =
                  this.appStateService.aktuellerAppStatus[
                    "anzahlAbstuetzPositionen"
                  ];
              }
              switch (this.SetupForm.value["Abstuetzverteilung"]) {
                case "VH":
                  this.stuetzeHRPos = this.stuetzeHLPos;
                  break;
                case "LR":
                  this.stuetzeVLPos = this.stuetzeHLPos;
                  break;
                case "0G":
                  this.stuetzeVLPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeVRPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeHLPos = 1;
                  this.stuetzeHRPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  break;
                case "50G":
                  this.stuetzeVLPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeVRPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeHLPos = 2;
                  this.stuetzeHRPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  break;
              }
              break;
            case "r":
              this.stuetzeHRPos--;
              if (this.stuetzeHRPos === 0) {
                this.stuetzeHRPos =
                  this.appStateService.aktuellerAppStatus[
                    "anzahlAbstuetzPositionen"
                  ];
              }
              switch (this.SetupForm.value["Abstuetzverteilung"]) {
                case "VH":
                  this.stuetzeHLPos = this.stuetzeHRPos;
                  break;
                case "LR":
                  this.stuetzeVRPos = this.stuetzeHRPos;
                  break;
                case "0G":
                  this.stuetzeVLPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeVRPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeHLPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeHRPos = 1;
                  break;
                case "50G":
                  this.stuetzeVLPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeVRPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeHLPos =
                    this.appStateService.aktuellerAppStatus[
                      "anzahlAbstuetzPositionen"
                    ];
                  this.stuetzeHRPos = 2;
                  break;
              }
          }
          break;
      }
      //      }
    }
    // pruefen ob Abstuetzung zulässig (wegen ausgewaehltem Support bei HV, VH, RL, LR und gleichmäßig)
    if (
      this.SetupForm.value["Abstuetzverteilung"] === "VH" ||
      this.SetupForm.value["Abstuetzverteilung"] === "LR"
    ) {
      if (
        this.stuetzenMuster.indexOf(
          String(this.stuetzeVLPos) +
            String(this.stuetzeVRPos) +
            String(this.stuetzeHLPos) +
            String(this.stuetzeHRPos)
        ) === -1
      ) {
        this.aendereAbstuetzung(pos1, pos2, pos3, pos4, absolut);
      } else {
        this.setzeAbstuetzungen();
      }
    } else {
      this.setzeAbstuetzungen();
    }

    this.kranKennung["abstuetzMuster"] =
      String(this.stuetzeVLPos) +
      String(this.stuetzeVRPos) +
      String(this.stuetzeHLPos) +
      String(this.stuetzeHRPos);
    this.appStateService.kranGewaehltNeu(this.kranKennung);
    this.erzeugeAbstuetzungsFilter();
  }
  erzeugeAbstuetzungsFilterWennAllesDa() {
    if (this.bitteWarten()) {
      setTimeout(() => this.erzeugeAbstuetzungsFilterWennAllesDa(), 200);
    } else {
      this.erzeugeAbstuetzungsFilter();
    }
  }
  erzeugeAbstuetzungsFilter() {
    let filterString = "";
    let zuSetzendeAbstuetzung = "";
    if (
      this.stuetzeHLPos === this.stuetzeVLPos &&
      this.stuetzeVLPos === this.stuetzeHRPos &&
      this.stuetzeHRPos === this.stuetzeVRPos
    ) {
      // symmetrische Abstuetzung
      let weite: string = allgemeineFunktionen
        .rundeZahl(
          parseFloat(
            this.stuetzenDaten[
              this.sucheStuetzeUeberPosition(this.stuetzeVLPos)
            ]["Strecke"]
          ) * 2,
          2
        )
        .toString();
      weite = this.pruefeWeiteAufZweiNachkommastellen(weite);
      //      filterString = 'x' + weite + this.laengenEinheit;
      for (const abstuetzung of this.abstuetzungen) {
        const werte = abstuetzung
          .substr(0, abstuetzung.length - this.laengenEinheit.length)
          .split("x");
        if (Math.abs(parseFloat(werte[1]) - parseFloat(weite)) <= 0.1) {
          //          filterString = abstuetzung.split('x')[0] + filterString;
          filterString = werte[0] + "x" + weite + this.laengenEinheit;
          break;
        }
      }
      // prüfe ob Abstuetzung vorhanden.
      if (!this.abstuetzungen.includes(filterString)) {
        filterString = this.passendenFilterSuchen(filterString, "x");
      }
      zuSetzendeAbstuetzung = filterString;
    } else if (
      this.stuetzeVLPos === this.stuetzeVRPos &&
      this.stuetzeHRPos === this.stuetzeHLPos
    ) {
      // VH oder HV
      const weiteVorne = this.pruefeWeiteAufZweiNachkommastellen(
        allgemeineFunktionen
          .rundeZahl(
            parseFloat(
              this.stuetzenDaten[
                this.sucheStuetzeUeberPosition(this.stuetzeVLPos)
              ]["Strecke"]
            ),
            2
          )
          .toString()
      );
      const weiteHinten = this.pruefeWeiteAufZweiNachkommastellen(
        allgemeineFunktionen
          .rundeZahl(
            parseFloat(
              this.stuetzenDaten[
                this.sucheStuetzeUeberPosition(this.stuetzeHLPos)
              ]["Strecke"]
            ),
            2
          )
          .toString()
      );
      if (this.stuetzeVLPos > this.stuetzeHRPos) {
        // VH
        filterString =
          "VH_" + weiteVorne + "/" + weiteHinten + this.laengenEinheit;
      } else {
        // HV
        filterString =
          "HV_" + weiteHinten + "/" + weiteVorne + this.laengenEinheit;
      }
      // prüfe ob Abstuetzung vorhanden.
      if (!this.abstuetzungen.includes(filterString)) {
        filterString = this.passendenFilterSuchen(filterString, "/", "_");
      }
      zuSetzendeAbstuetzung = filterString;
    } else if (
      this.stuetzeVLPos === this.stuetzeHLPos &&
      this.stuetzeVRPos === this.stuetzeHRPos
    ) {
      // RL oder LR
      const weiteLinks = this.pruefeWeiteAufZweiNachkommastellen(
        allgemeineFunktionen
          .rundeZahl(
            parseFloat(
              this.stuetzenDaten[
                this.sucheStuetzeUeberPosition(this.stuetzeVLPos)
              ]["Strecke"]
            ),
            2
          )
          .toString()
      );
      const weiteRechts = this.pruefeWeiteAufZweiNachkommastellen(
        allgemeineFunktionen
          .rundeZahl(
            parseFloat(
              this.stuetzenDaten[
                this.sucheStuetzeUeberPosition(this.stuetzeVRPos)
              ]["Strecke"]
            ),
            2
          )
          .toString()
      );
      if (this.stuetzeVLPos > this.stuetzeVRPos) {
        filterString =
          "LR_" + weiteLinks + "/" + weiteRechts + this.laengenEinheit;
      } else {
        filterString =
          "RL_" + weiteRechts + "/" + weiteLinks + this.laengenEinheit;
      }
      // prüfe ob Abstuetzung vorhanden.
      if (!this.abstuetzungen.includes(filterString)) {
        filterString = this.passendenFilterSuchen(filterString, "/", "_");
      }
      zuSetzendeAbstuetzung = filterString;
    } else if (
      allgemeineFunktionen.meinXOR(
        allgemeineFunktionen.meinXOR(
          allgemeineFunktionen.meinXOR(
            this.stuetzeVLPos === 1,
            this.stuetzeVRPos === 1
          ),
          this.stuetzeHRPos === 1
        ),
        this.stuetzeHLPos === 1
      ) ||
      allgemeineFunktionen.meinXOR(
        allgemeineFunktionen.meinXOR(
          allgemeineFunktionen.meinXOR(
            this.stuetzeVLPos === 2,
            this.stuetzeVRPos === 2
          ),
          this.stuetzeHRPos === 2
        ),
        this.stuetzeHLPos === 2
      )
    ) {
      // 0G oder 50G Abstützung
      let eingezogeneStuetze: number;
      let ausgefahreneStuetze: number;
      let eingezogeneStuetzeMarker: string;
      if (this.stuetzeVLPos === 1 || this.stuetzeVLPos === 2) {
        eingezogeneStuetze = this.stuetzeVLPos;
        ausgefahreneStuetze = this.stuetzeVRPos;
        eingezogeneStuetzeMarker = "/1xVL_";
      } else if (this.stuetzeVRPos === 1 || this.stuetzeVRPos === 2) {
        eingezogeneStuetze = this.stuetzeVRPos;
        ausgefahreneStuetze = this.stuetzeVLPos;
        eingezogeneStuetzeMarker = "/1xVR_";
      } else if (this.stuetzeHLPos === 1 || this.stuetzeHLPos === 2) {
        eingezogeneStuetze = this.stuetzeHLPos;
        ausgefahreneStuetze = this.stuetzeHRPos;
        eingezogeneStuetzeMarker = "/1xHL_";
      } else if (this.stuetzeHRPos === 1 || this.stuetzeHRPos === 2) {
        eingezogeneStuetze = this.stuetzeHRPos;
        ausgefahreneStuetze = this.stuetzeHLPos;
        eingezogeneStuetzeMarker = "/1xHR_";
      }
      filterString =
        this.pruefeWeiteAufZweiNachkommastellen(
          allgemeineFunktionen
            .rundeZahl(
              parseFloat(
                this.stuetzenDaten[
                  this.sucheStuetzeUeberPosition(ausgefahreneStuetze)
                ]["Strecke"]
              ),
              2
            )
            .toString()
        ) +
        eingezogeneStuetzeMarker +
        this.pruefeWeiteAufZweiNachkommastellen(
          allgemeineFunktionen
            .rundeZahl(
              parseFloat(
                this.stuetzenDaten[
                  this.sucheStuetzeUeberPosition(eingezogeneStuetze)
                ]["Strecke"]
              ),
              2
            )
            .toString()
        ) +
        this.laengenEinheit;
      filterString = this.passendenFilterSuchen(filterString, "", "");
      zuSetzendeAbstuetzung = filterString;
    }

    // Erlaubte Drehrichtungen zu Abstuetzungen lesen
    this.craneListService
      .getFilteredPartsSelectionData(
        "",
        this.gesetzteIdentnr,
        this.gesetztesGegengew,
        this.gesetzteHALaenge,
        "",
        "",
        "",
        zuSetzendeAbstuetzung,
        this.gesetzteHAAusfahrf,
        this.Abstuetzverteilung,
        "-1"
      )
      .then((res) => {
        // erlaubte Drehbereiche erzeugen und in Liste schreiben
        this.DrehbereichListe = [];
        for (const dr of res["DrehrichtungenMitBereichen"]) {
          this.DrehbereichListe.push(new Drehbereich(dr[1], parseFloat(dr[0])));
        }
      });
    this.gesetzteAbstuetzung = zuSetzendeAbstuetzung;
    this.SetupForm.get("AbstuetzW").setValue(zuSetzendeAbstuetzung);
    this.gesetzteAbstuetzungUngespiegelt = filterString
      .replace("LR", "RL")
      .replace("VR", "VL")
      .replace("HR", "HL");
    if (filterString !== "" && filterString !== undefined) {
      this.KranFilterTabelle.widget.filterColumn(
        "AbstuetzW",
        "equal",
        filterString,
        "and",
        true
      );
    }
  }

  /**
   * Diese Funktion sucht eine passende Abstützung in den Daten der Datenbank. Es wird versucht rundungsprobleme zu umgehen.
   * @param {string} filterString - der gesuchte Filterstring
   * @param {string} delimiter1 - Der Trenner zwisachen den beiden Werten für Vorne/hinten bzw Rechts/Links
   * @param {string} delimiter2 - Der Trenner zwischen der Anzeige der Art der Abstützung (RL, LR, VH, HV) und den Werten.
   */
  passendenFilterSuchen(
    filterString: string,
    delimiter1: string,
    delimiter2: string = ""
  ): string {
    if (filterString.indexOf("/1x") > -1) {
      // 0G oder 50G
      const langAusFilter: number = parseFloat(filterString.split("/")[0]);
      const kurzAusFilter: number = parseFloat(
        filterString
          .split("_")[1]
          .substr(
            0,
            filterString.split("_")[1].length - this.laengenEinheit.length
          )
      );
      const woAusFilter: string = filterString.split("/")[1].split("_")[0];
      for (const abstuetzung of this.abstuetzungen) {
        if (abstuetzung.indexOf("/1x") > -1) {
          // nur prüfen wenn wir auch eine 0% oder 50% Abstützung haben
          const langAusAbstuetzung: number = parseFloat(
            abstuetzung.split("/")[0]
          );
          const kurzAusAbstuetzung: number = parseFloat(
            abstuetzung
              .split("_")[1]
              .substr(
                0,
                abstuetzung.split("_")[1].length - this.laengenEinheit.length
              )
          );
          const woAusAbstuetzung: string = abstuetzung
            .split("/")[1]
            .split("_")[0];
          if (
            Math.abs(langAusFilter - langAusAbstuetzung) <= 0.1 &&
            Math.abs(kurzAusFilter - kurzAusAbstuetzung) <= 0.1 &&
            woAusFilter === woAusAbstuetzung
          ) {
            filterString = abstuetzung;
            break;
          }
        }
      }
    } else {
      // symmetrisch, VH, HV, RL oder LR
      const orgVerteilungsWert: string = filterString.substr(0, 2);
      if (orgVerteilungsWert === "LR") {
        filterString = filterString.replace("LR", "RL");
      }
      const verteilungsWert = filterString.substr(0, 2);
      for (const abstuetzung of this.abstuetzungen) {
        if (abstuetzung.indexOf(delimiter1) > -1) {
          const ausAbstuetzung = abstuetzung.split(delimiter1)[1];
          const ausFilter = filterString.split(delimiter1)[1];
          const wert1AusFilter =
            delimiter2 === ""
              ? filterString.split(delimiter1)[0]
              : filterString.split(delimiter1)[0].split(delimiter2)[1];
          const wert1AusAbstuetzung =
            delimiter2 === ""
              ? abstuetzung.split(delimiter1)[0]
              : abstuetzung.split(delimiter1)[0].split(delimiter2)[1];
          if (
            Math.abs(
              parseFloat(
                ausAbstuetzung.substr(
                  0,
                  ausAbstuetzung.length - this.laengenEinheit.length
                )
              ) -
                parseFloat(
                  ausFilter.substr(
                    0,
                    ausFilter.length - this.laengenEinheit.length
                  )
                )
            ) <= 0.1 &&
            Math.abs(
              parseFloat(wert1AusFilter) - parseFloat(wert1AusAbstuetzung)
            ) <= 0.1 &&
            abstuetzung.substr(0, verteilungsWert.length) === verteilungsWert
          ) {
            filterString = abstuetzung;
            break;
          }
        }
      }
      if (orgVerteilungsWert === "LR") {
        filterString = filterString.replace("RL", "LR");
      }
    }
    return filterString;
  }
  pruefeWeiteAufZweiNachkommastellen(weite: string) {
    if (weite.substr(weite.length - 2, 1) === ".") {
      weite += "0";
    }
    return weite;
  }
  sucheStuetzeUeberPosition(stuetzenPosition: number) {
    let retStuetze;
    for (const stuetze in this.stuetzenDaten) {
      if (this.stuetzenDaten.hasOwnProperty(stuetze)) {
        if (
          this.stuetzenDaten[stuetze]["Position"].toString() ===
          stuetzenPosition.toString()
        ) {
          retStuetze = stuetze;
          break;
        }
      }
    }
    return retStuetze;
  }
  aendereAbstuetzverteilung(value: string) {
    this.resetFilter("nurRuest");
    this.Abstuetzverteilung = value;
    this.SetupForm.get("Abstuetzverteilung").setValue(this.Abstuetzverteilung);
    this.stuetzenDaten = undefined;
    if (
      !(
        this.gesetzteAbstuetzung.indexOf("1x") === -1 &&
        this.gesetzteAbstuetzung.indexOf("x") > -1
      ) ||
      this.Abstuetzverteilung === "0G" ||
      this.Abstuetzverteilung === "50G"
    ) {
      // Ich bin entweder in der Verteilung '0G', '50G' oder es ist eine symmetrische Abstuetzung gewählt.
      this.gesetzteAbstuetzung = "";
      this.SetupForm.get("AbstuetzW").setValue("");
      this.gesetzteAbstuetzungUngespiegelt = "";
      this.stuetzeVLPos =
        this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
      this.stuetzeVRPos =
        this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
      this.stuetzeHLPos =
        this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
      switch (this.Abstuetzverteilung) {
        case "0G":
          this.stuetzeHRPos = 1;
          break;
        case "50G":
          this.stuetzeHRPos = 2;
          break;
        default:
          this.stuetzeHRPos =
            this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"];
          break;
      }
    }
    const tempIdentnr: string = this.gesetzteIdentnr;
    this.gesetzteIdentnr = "";
    this.setzeAbstuetzungen();
    this.holeKranRuestzustaende(
      this.gesetzteIdentnr,
      this.gesetztesGegengew,
      this.gesetzteHALaenge,
      this.gesetzteAbstuetzungUngespiegelt,
      this.gesetzteHAAusfahrf,
      this.Abstuetzverteilung,
      this.OWWinkel
    ).then(() => {
      if (this.identnummern.indexOf(tempIdentnr) > 0) {
        // vorher gewaehlte Identnr passt noch. Also wird sie wieder gesetzt und die restlichen aus der Auswahl entfernt.
        this.gesetzteIdentnr = tempIdentnr;
        this.holeKranRuestzustaende(
          this.gesetzteIdentnr,
          this.gesetztesGegengew,
          this.gesetzteHALaenge,
          this.gesetzteAbstuetzungUngespiegelt,
          this.gesetzteHAAusfahrf,
          this.Abstuetzverteilung,
          this.OWWinkel
        );
        this.KranFilterTabelle.widget.filterColumn(
          "Identnr",
          "equal",
          this.gesetzteIdentnr,
          "and",
          true
        );
      } else {
        this.KranFilterTabelle.widget.clearFiltering("Identnr");
      }
    });
    this.appStateService.appStatusSetzen({
      abstuetzVerteilung: this.Abstuetzverteilung,
    });
  }
  setzeAbstuetzungen() {
    this.stuetzeVL =
      this.grafikBasis +
      "Stuetzen_R_" +
      this.stuetzeVLPos +
      "-" +
      this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"] +
      ".png";
    this.stuetzeVR =
      this.grafikBasis +
      "Stuetzen_L_" +
      this.stuetzeVRPos +
      "-" +
      this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"] +
      ".png";
    this.stuetzeHL =
      this.grafikBasis +
      "Stuetzen_R_" +
      this.stuetzeHLPos +
      "-" +
      this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"] +
      ".png";
    this.stuetzeHR =
      this.grafikBasis +
      "Stuetzen_L_" +
      this.stuetzeHRPos +
      "-" +
      this.appStateService.aktuellerAppStatus["anzahlAbstuetzPositionen"] +
      ".png";
  }
  aendereOWWinkel(e: any, force = false, ladeRuestzustaende = true) {
    clearTimeout(this.aendereWerte);
    this.aendereWerte = setTimeout(() => {
      if (e.target instanceof HTMLInputElement) {
        // OW Änderung durch Eingabe eines Wertes
        e = e.target.value;
        e = e.replace(",", ".");
        if (e === "") {
          this.OWWinkel = "";
          this.gesetzterDrehbereich = ["0"];
        } else {
          while (e < 0) {
            e = 360 + parseFloat(e);
          }
          e = e % 360;
          this.OWWinkel = e;
          this.gesetzterDrehbereich = [];
          for (const drehber of this.DrehbereichListe) {
            if (drehber.enthaelt(e)) {
              this.gesetzterDrehbereich.push(
                drehber.holeDrehrichtung().toString()
              );
            }
          }
          this.gesetzterDrehbereich = allgemeineFunktionen.arrayUnique(
            this.gesetzterDrehbereich
          );
          switch (this.gesetzterDrehbereich.length) {
            case 1:
              // Eine Drehrichtung oder Rundum möglich
              switch (this.gesetzterDrehbereich[0]) {
                case "1":
                  // vorne
                  this.drehWinkelGrafik =
                    "deps/images/KranDraufsicht_vorne_grau.png";
                  break;
                case "2":
                  // hinten
                  this.drehWinkelGrafik =
                    "deps/images/KranDraufsicht_hinten_grau.png";
                  break;
                case "3":
                  // rechts
                  this.drehWinkelGrafik =
                    "deps/images/KranDraufsicht_rechts_grau.png";
                  break;
                case "4":
                  // links
                  this.drehWinkelGrafik =
                    "deps/images/KranDraufsicht_links_grau.png";
                  break;
                case "-1":
                case "0":
                default:
                  // rundum
                  this.drehWinkelGrafik = "deps/images/KranDraufsicht.png";
                  break;
              }
              break;
            case 2:
              // Es sind zwei Drehrichtungne möglich
              if (this.gesetzterDrehbereich.includes("0")) {
                // rundum
                this.drehWinkelGrafik = "deps/images/KranDraufsicht.png";
              } else if (this.gesetzterDrehbereich.includes("1")) {
                // vorne ist dabei
                if (this.gesetzterDrehbereich.includes("3")) {
                  // rechts dabei also vorne und rechts
                  this.drehWinkelGrafik =
                    "deps/images/KranDraufsicht_vornerechts_grau.png";
                } else if (this.gesetzterDrehbereich.includes("4")) {
                  this.drehWinkelGrafik =
                    "deps/images/KranDraufsicht_vornelinks_grau.png";
                } else {
                  // eigentlich muss links oder rechts gesetzt sein. FEHLER!! Daher vorsichtshalber nur vorne setzen
                  this.drehWinkelGrafik =
                    "deps/images/KranDraufsicht_vorne_grau.png";
                }
              } else if (this.gesetzterDrehbereich.includes("2")) {
                // hinten ist dabei
                if (this.gesetzterDrehbereich.includes("3")) {
                  // rechts dabei also vorne und rechts
                  this.drehWinkelGrafik =
                    "deps/images/KranDraufsicht_hintenrechts_grau.png";
                } else if (this.gesetzterDrehbereich.includes("4")) {
                  this.drehWinkelGrafik =
                    "deps/images/KranDraufsicht_hintenlinks_grau.png";
                } else {
                  // eigentlich muss links oder rechts gesetzt sein. FEHLER!! Daher vorsichtshalber nur hinten setzen
                  this.drehWinkelGrafik =
                    "deps/images/KranDraufsicht_hinten_grau.png";
                }
              } else {
                console.log(
                  "Hier stimmt was nicht. Wenn mehrere Bereiche dabei sind muss vorne oder hinten dabei sein!"
                );
                // Hier ist was Falsch. Setze aber vorsichtshalber rundum!
                this.drehWinkelGrafik = "deps/images/KranDraufsicht.png";
              }
              break;
            default:
            case 0:
              // alle Drehrichtungen möglich
              this.drehWinkelGrafik = "deps/images/KranDraufsicht.png";
              break;
          }
        }
      } else {
        // Wahl durch anklicken der Grafik
        if (e === "") {
          this.OWWinkel = "";
          this.gesetzterDrehbereich = [""];
          this.drehWinkelGrafik = "deps/images/KranDraufsicht.png";
        } else if (e > 315 || e <= 45) {
          this.OWWinkel = force ? e : "0";
          this.gesetzterDrehbereich = ["2"];
          this.drehWinkelGrafik = "deps/images/KranDraufsicht_hinten_grau.png";
        } else if (e > 45 && e <= 135) {
          this.OWWinkel = force ? e : "90";
          this.gesetzterDrehbereich = ["4"];
          this.drehWinkelGrafik = "deps/images/KranDraufsicht_links_grau.png";
        } else if (e > 135 && e <= 225) {
          this.OWWinkel = force ? e : "180";
          this.gesetzterDrehbereich = ["1"];
          this.drehWinkelGrafik = "deps/images/KranDraufsicht_vorne_grau.png";
        } else if (e > 225 && e <= 315) {
          this.OWWinkel = force ? e : "270";
          this.gesetzterDrehbereich = ["3"];
          this.drehWinkelGrafik = "deps/images/KranDraufsicht_rechts_grau.png";
        } else {
          console.log("Komisch");
        }
      }
      if (ladeRuestzustaende) {
        this.holeKranRuestzustaende(
          this.gesetzteIdentnr,
          this.gesetztesGegengew,
          this.gesetzteHALaenge,
          "", // AbstuetzW darf nicht mit gegeben werden, da sonst nicht alle möglichen Abstuetzungen durchkommen.
          this.gesetzteHAAusfahrf,
          this.Abstuetzverteilung,
          this.gesetzterDrehbereich.join(",")
        );
      }
      if (this.OWWinkel !== "") {
        // Filter setzten
        // XXX Oder verknüpfung auf Filter muss gemacht werden!
        this.KranFilterTabelle.widget.filterColumn(
          "Drehrichtung",
          "equal",
          this.gesetzterDrehbereich[0],
          "and",
          true
        );
        if (parseFloat(this.OWWinkel) > 180) {
          const test = allgemeineFunktionen.rundeZahl(
            parseFloat(this.OWWinkel) - 360,
            2
          );
          this.OWWinkel = test.toString();
        }
      } else {
        this.KranFilterTabelle.widget.clearFiltering("Drehrichtung");
        this.drehWinkelGrafik = "deps/images/KranDraufsicht.png";
      }
      this.kranKennung["owWinkel"] = this.OWWinkel;
      this.appStateService.kranGewaehltNeu(this.kranKennung);
    }, 100);
  }
  // sucheKkran muss nun hier auch noch mal kommen, da wir ab Angular7 ngModel  nich tmehr mit ReactiveForms nutzen kann
  sucheKran(Abstuetzverteilung: string = "") {
    this.RHLRadius = this.SetupForm.get("Radius").value;
    this.RHLLast = this.SetupForm.get("Last").value;
    this.RHLHoehe = this.SetupForm.get("Hoehe").value;
    super.sucheKran(Abstuetzverteilung);
  }
}
